<template>
  <div>
    <div
      class="text-center"
      v-loading="mapLoading"
      element-loading-spinner="qc-spinner"
    >
      <button
        @click.prevent="
          mapRegion = 'world';
          drawCharts();
        "
        class="btn"
        :class="{ 'btn-fill': mapRegion == 'world' }"
      >
        World</button
      >&nbsp;
      <button
        @click.prevent="
          mapRegion = '150';
          drawCharts();
        "
        class="btn"
        :class="{ 'btn-fill': mapRegion == '150' }"
      >
        Europe</button
      >&nbsp;
      <button
        @click.prevent="
          mapRegion = '142';
          drawCharts();
        "
        class="btn"
        :class="{ 'btn-fill': mapRegion == '142' }"
      >
        Asia</button
      >&nbsp;
      <button
        @click.prevent="
          mapRegion = '002';
          drawCharts();
        "
        class="btn"
        :class="{ 'btn-fill': mapRegion == '002' }"
      >
        Africa</button
      >&nbsp;
      <button
        @click.prevent="
          mapRegion = '019';
          drawCharts();
        "
        class="btn"
        :class="{ 'btn-fill': mapRegion == '019' }"
      >
        Americas</button
      >&nbsp;
      <button
        @click.prevent="
          mapRegion = '009';
          drawCharts();
        "
        class="btn"
        :class="{ 'btn-fill': mapRegion == '009' }"
      >
        Oceania</button
      >&nbsp;
    </div>
    <div id="chart_div"></div>
  </div>
</template>
<script>
export default {
  name: "coverage-map",
  data() {
    return {
      map: null,
      mapData: null,
      mapRegion: "world",
      mapLoading: false,
    };
  },
  mounted() {
    google.charts.load("current", {
      packages: ["geochart", "table"],
      mapsApiKey: "AIzaSyBmBqEYT1PiY0LzhMFE7ENmBYvI8ZSEfXo",
    });
    google.charts.setOnLoadCallback(this.getChartData);
  },
  methods: {
    getChartData() {
      var _this = this;
      this.mapLoading = true;
      this.$api.getChartData().then((response) => {
        _this.chartData = new google.visualization.DataTable(response.data);
        _this.drawCharts();
        _this.mapLoading = false;
      });
    },
    drawCharts(delay) {
      if (this.chartData && this.region == null) {
        if (!delay) {
          delay = 0;
        }
        var _this = this;
        setTimeout(function() {
          try {
            _this.map = new google.visualization.GeoChart(
              document.getElementById("chart_div")
            );

            google.visualization.events.addListener(
              _this.map,
              "select",
              function() {
                var selectionIdx = _this.map.getSelection()[0].row;
                var countryCode = _this.chartData.getValue(selectionIdx, 1);
                var name = _this.chartData.getValue(selectionIdx, 0);
                _this.$emit("selectRegion", { id: countryCode, name: name });
              }
            );

            var options = {
              backgroundColor: "#ffffff",
              legend: "none",
              datalessRegionColor: "#9bd6db",
              colorAxis: {
                minValue: 0,
                maxValue: 1,
                colors: ["#9bd6db", "#9bd6db"],
              },
              height: "100%",
              width: "100%",
              region: "world",
              tooltip: { isHtml: true },
              region: _this.mapRegion,
            };

            _this.map.draw(_this.chartData, options);
          } catch (error) {
            if (error.message == "Container is not defined") {
              // Specifically do nothing, who gives a f#%k
            } else {
              throw error;
            }
          }
        }, delay);
      }
    },
  },
};
</script>
<style>
/*
.google-visualization-tooltip {
  border: solid 1px #3ca5aa !important;
  border-radius: 6px;
}

.google-visualization-tooltip-item-list {
  list-style-type: none;
  margin: 0 !important;
  padding: 0 !important;
}

.google-visualization-tooltip-item:nth-child(2) {
  display: none;
}
*/
</style>
